export const COLORS = {
  gold: 'rgba(255, 215, 0, 1)',
  gold_hover: 'rgba(225,199,54)',
  goldGradient: 'linear-gradient(180deg, #FFD700 0%, #978939 100%)',
  goldGradientLeftToRight: 'linear-gradient(20deg, #FFD700 30%, rgb(250, 244, 81) 70%)',
  gold_op8: 'rgba(255, 215, 0, 0.8)',
  metallicGold: 'rgba(225, 199, 54, 1)',
  pureBlack: 'rgba(0, 0, 0, 1)',
  gray: 'rgba(196, 196, 196, 1)',
  gray_op8: 'rgba(196, 196, 196, 0.8)',
  darkGray: 'rgb(139, 139, 139)',
  metallic: 'rgb(217, 217, 217)',
  black: 'rgba(0, 0, 0)',
  lightGray: 'rgba(247, 243, 243, 1)',
  semiLightGray: 'rgba(225, 225, 225, 1)',
  lightGreen: 'rgb(232, 255, 231)',
  red: 'rgba(249, 0, 0, 1)'
}
